<template>
  <div>
    <div class="text-sm mb-3">
      Use * como caractére coringa para buscar oportunidades de forma
      estratégica:
      <ul class="text-list">
        <li class="list-item">
          <b class="bg-hint">123*</b> - Encontra oportunidades cujo código
          começa com 123.
        </li>
        <li class="list-item">
          <b class="bg-hint">*123</b> - Encontra oportunidades cujo código
          termina com 123.
        </li>
        <li class="list-item">
          <b class="bg-hint">*123*</b> - Encontra oportunidades que contêm 123
          em qualquer parte do código.
        </li>
      </ul>
    </div>
    <div class="text-sm mb-3">
      Use # para buscar pelo identificador único da oportunidade:
      <ul class="text-list">
        <li class="list-item">
          <b class="bg-hint">#123</b> - Busca a oportunidade pelo identificador
          único.
        </li>
      </ul>
    </div>
    <hr class="mb-2" />
    <div class="d-inline-flex w-100">
      <div class="ml-auto"></div>
      <b-button variant="outline-exitos" size="sm" @click="$emit('apply')">
        Experimentar
      </b-button>
      <b-button variant="exitos" size="sm" @click="$emit('done')">
        Entendi
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  emits: ["done", "apply"],
};
</script>
<style scoped lang="scss">
.text-list {
  font-size: 0.875rem;
  padding-left: 1em;
  padding-top: 0.5em;
  list-style: none;

  .list-item {
    margin-bottom: 10px;
  }
}

.bg-hint {
  background-color: rgba(59, 89, 153, 0.075);
  color: var(--exitos, #225373);
  padding: 2px 4px;
  border-radius: 4px;
}
</style>
